import { requestHandler, responseSuccessHandler, responseErrorHandler } from '@bv/utils/http';
import axios from 'axios';

const URL = import.meta.env.VITE_API_BASE_URL;
const axiosDefaultConfig = {
  baseURL: URL + '/' + import.meta.env.VITE_API_VERSION,
  headers: {
    Accept: '*',
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
};

const axiosInstance = axios.create(axiosDefaultConfig);

// Use the shared request handler from @bv
axiosInstance.interceptors.request.use(
  async (config) => {
    // Set fullResponse to true so the shared response handler returns the full object
    config.fullResponse = true;
    return requestHandler(config);
  },
  (error) => Promise.reject(error),
);

// Use the shared response handlers from @bv
axiosInstance.interceptors.response.use(responseSuccessHandler, responseErrorHandler);

export default axiosInstance;
